import { render, staticRenderFns } from "./shipment_tracking.vue?vue&type=template&id=706d2c84&"
import script from "./shipment_tracking.vue?vue&type=script&lang=js&"
export * from "./shipment_tracking.vue?vue&type=script&lang=js&"
import style0 from "./shipment_tracking.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports